import React from 'react'
import { FulfilmentType } from '../../../../../models/fulfilment'
import { FulfilmentSelect } from '../../FulfilmentSelect'
import { LineItemFulfilmentAddress } from '../LineItemFulfilmentAddress'
import { LineItemFulfilmentNote } from '../LineItemFulfilmentNote'
import { OutdatedTaxCategoryWarning } from '../OutdatedTaxCategoryWarning'
import { OutletSelect } from '../OutletSelect'
import {
  LineItemDisplayFulfilmentProps,
  useLineItemDisplayFulfilmentModel,
} from './useLineItemDisplayFulfilmentModel'

export const LineItemDisplayFulfilment: React.FC<LineItemDisplayFulfilmentProps> = props => {
  const model = useLineItemDisplayFulfilmentModel(props)

  return (
    <div className="uc-base">
      <div className="flex flex-col gap-4">
        <OutdatedTaxCategoryWarning lineItem={model.defaultLineItem} />
        <FulfilmentSelect
          showUnspecified
          disabled={model.isDisabled}
          onTypeChange={model.handleTypeChange}
          defaultType={model.currentLineItem?.fulfilmentType}
          stretched
          message={model.fulfilmentMessage}
          outOfStockMessage={model.outOfStockMessage}
        />

        {model.shouldShowOutletSelect && (
          <OutletSelect
            className="vd-mb5"
            disabled={model.isFulfilmentOutletDisabled}
            includeAvailability
            initialSelectedOutletId={model.currentLineItem?.fulfilmentOutletId}
            onOutletChange={outlet => model.setFulfilmentOutletId(outlet.id)}
            onSelectedOutletIdChange={model.handleSelectedOutletIdChange}
            productId={model.currentLineItem?.product.id}
            showLabel
          />
        )}

        {model.shouldShowFulfilmentAddress && (
          <LineItemFulfilmentAddress
            fulfillmentDetail={model.fulfilmentDetail}
            lineItemLocalId={model.defaultLineItem.localId}
            isModalOpeningOnError={model.fulfilmentDetail?.shouldAddNewAddress}
          />
        )}

        {!!model.currentLineItem?.fulfilmentType &&
          model.currentLineItem.fulfilmentType !==
            FulfilmentType.UNSPECIFIED && (
            <LineItemFulfilmentNote
              note={model.fulfilmentDetail?.note || ''}
              isDisabled={model.isDisabled}
              onChange={model.setFulfilmentNote}
              onErrorsChange={model.handleNoteErrorsChange}
            />
          )}
      </div>
    </div>
  )
}
